/**
 * The three ideas on the Workflows page, as one small picture.
 *
 * People (in apps) and Scout (through integrations) both change records only
 * by going through a workflow.
 */

import { ArrowRight, CloudDownload, Database, Users, Workflow } from "lucide-react";
import { Link } from "react-router-dom";

import styles from "./workflows.module.css";

export function HowItFits() {
  return (
    <figure className={styles.fits} aria-label="How apps, workflows and integrations fit together">
      <p className={styles.fitsLabel}>How it fits together</p>
      <div className={styles.fitsRow}>
        <div className={styles.fitsSources}>
          <div className={styles.fitsBox}>
            <span className={styles.fitsIcon}>
              <Users size={16} aria-hidden />
            </span>
            <div>
              <p className={styles.fitsTitle}>People work in apps</p>
              <p className={styles.fitsText}>
                A scoring desk records a match. The operations console runs an event.
              </p>
              <a className={styles.fitsLink} href="#apps">
                See the apps
              </a>
            </div>
          </div>
          <div className={styles.fitsBox}>
            <span className={styles.fitsIcon}>
              <CloudDownload size={16} aria-hidden />
            </span>
            <div>
              <p className={styles.fitsTitle}>Scout data comes in through integrations</p>
              <p className={styles.fitsText}>
                No code. Pick a Scout job and the import it fills. The plugin says which imports
                each workflow takes.
              </p>
              <Link className={styles.fitsLink} to="/integrations">
                See the integrations
              </Link>
            </div>
          </div>
        </div>

        <span className={styles.fitsArrow} aria-hidden>
          <ArrowRight size={18} />
        </span>

        <div className={`${styles.fitsBox} ${styles.fitsMain}`}>
          <span className={styles.fitsIcon}>
            <Workflow size={16} aria-hidden />
          </span>
          <div>
            <p className={styles.fitsTitle}>Every change goes through a workflow</p>
            <p className={styles.fitsText}>
              It checks the rules, then runs the actions. The flow diagram draws both.
            </p>
          </div>
        </div>

        <span className={styles.fitsArrow} aria-hidden>
          <ArrowRight size={18} />
        </span>

        <div className={styles.fitsBox}>
          <span className={styles.fitsIcon}>
            <Database size={16} aria-hidden />
          </span>
          <div>
            <p className={styles.fitsTitle}>omnium saves the records</p>
            <p className={styles.fitsText}>
              Fixtures, scores, results, medal tables and players. Only a workflow writes them.
            </p>
          </div>
        </div>
      </div>
    </figure>
  );
}
